module.exports = __webpack_public_path__ + "img/ziyuanxiazai_im.e8e6814e.png";